﻿(function ($) {

	//Internal methods
	var methods = {
		equalizeRows: function() {
			var self = this;
			var container = $(this)[0];

			if(window.eqHeightsExecuting) {
				return;
			}

			window.eqHeightsExecuting = true;

			if(container.length == 0) {
				//Nothing to see here.
				return;
			}

			//Make sure no temporary scrollbars popup. This will affect the top-position calculations.
			container.style.overflow = 'hidden';
			var equalizeChildren = container.getAttribute('data-eq-child').split(',');

			for (var i = 0; i < equalizeChildren.length; i++) {
				var elements = container.querySelectorAll(equalizeChildren[i]);
				methods.equalizeRow.call(self, elements);
			}
		},

		equalizeRow: function(elements) {
			var self = this;
			if(elements.length == 0) {
				window.eqHeightsExecuting = false;
				return;
			}

			var rowMaxHeight = 0;
			var currentRowStart = 0;
			var topPosition = 0;
			var rowElements = [];

			for (var j = 0; j < elements.length; j++) {
				var el = elements[j];
				topPosition = el.getBoundingClientRect().top;

				//Release the height so the required height can be calculated.
				el.style.height = 'auto';

				if (currentRowStart != topPosition && rowElements.length > 0) {
					methods.apply.call(self, rowElements, rowMaxHeight, function() {
						var subset = Array.prototype.slice.call(elements, j);
						methods.equalizeRow.call(self, subset);
					});

					return;
				} else if(currentRowStart != topPosition && rowElements.length == 0) {
					currentRowStart = topPosition;
				}
				if (rowMaxHeight < el.clientHeight) {
					rowMaxHeight = el.clientHeight;
				}

				rowElements.push(el);

				if(j == elements.length - 1) {
					methods.apply.call(self, rowElements, rowMaxHeight);
					window.eqHeightsExecuting = false;
				}
			}
		},

		apply: function(elms, height, callback) {
			var self = this;
			if(elms.length == 0) return;
			var applyElements = elms.slice(0);

			setTimeout(function() {
				for (var i = 0; i < applyElements.length; i++) {
					applyElements[i].style.height = height + 'px';
				}
				if(callback) callback.call(self);
			}, 0);
		}
	};

	$.fn.equalHeight = function(options) {
		return methods.equalizeRows.apply(this, arguments);
	};
})(jQuery);